{
  "level": "nbbmov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:nbbmov",
    "objects": "AREAS.E3:nbbmov.e3",
    "mesh": "TREES.E3:nbbmov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 393,
      "centroid": [
        -2538.226318359375,
        -4080.748046875,
        1098.373779296875
      ],
      "bbox_min": [
        -2542.07421875,
        -4084.4130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2534.37841796875,
        -4077.0830078125,
        1099.623779296875
      ],
      "dimensions_source": {
        "span_x": 7.69580078125,
        "span_y": 7.330078125,
        "height_z": 2.5,
        "door_width": 7.69580078125,
        "door_depth": 7.330078125,
        "leaf_depth": 7.330078125,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          -0.866,
          0.5,
          0.0
        ]
      },
      "vertices": [
        [
          -2540.34228515625,
          -4082.4130859375,
          1098.123779296875
        ],
        [
          -2538.6103515625,
          -4083.4130859375,
          1097.123779296875
        ],
        [
          -2542.07421875,
          -4081.4130859375,
          1099.123779296875
        ],
        [
          -2536.1103515625,
          -4079.0830078125,
          1097.623779296875
        ],
        [
          -2539.57421875,
          -4077.0830078125,
          1099.623779296875
        ],
        [
          -2537.84228515625,
          -4078.0830078125,
          1098.623779296875
        ],
        [
          -2542.07421875,
          -4081.4130859375,
          1099.623779296875
        ],
        [
          -2540.34228515625,
          -4082.4130859375,
          1098.623779296875
        ],
        [
          -2538.6103515625,
          -4083.4130859375,
          1097.623779296875
        ],
        [
          -2537.84228515625,
          -4078.0830078125,
          1098.123779296875
        ],
        [
          -2536.1103515625,
          -4079.0830078125,
          1097.123779296875
        ],
        [
          -2539.57421875,
          -4077.0830078125,
          1099.123779296875
        ],
        [
          -2538.6103515625,
          -4083.4130859375,
          1098.123779296875
        ],
        [
          -2540.34228515625,
          -4082.4130859375,
          1099.123779296875
        ],
        [
          -2536.87841796875,
          -4084.4130859375,
          1097.123779296875
        ],
        [
          -2537.84228515625,
          -4078.0830078125,
          1099.623779296875
        ],
        [
          -2536.1103515625,
          -4079.0830078125,
          1098.623779296875
        ],
        [
          -2534.37841796875,
          -4080.0830078125,
          1097.623779296875
        ],
        [
          -2536.87841796875,
          -4084.4130859375,
          1097.623779296875
        ],
        [
          -2540.34228515625,
          -4082.4130859375,
          1099.623779296875
        ],
        [
          -2538.6103515625,
          -4083.4130859375,
          1098.623779296875
        ],
        [
          -2534.37841796875,
          -4080.0830078125,
          1097.123779296875
        ],
        [
          -2536.1103515625,
          -4079.0830078125,
          1098.123779296875
        ],
        [
          -2537.84228515625,
          -4078.0830078125,
          1099.123779296875
        ]
      ],
      "plane_distance": -158.771
    },
    {
      "tag": "CSlidingDoor piece: mainexit",
      "entity_class": "CSlidingDoor",
      "piece_name": "mainexit",
      "offset": 2942,
      "centroid": [
        -2534.1372802734377,
        -4056.666064453125,
        1106.023779296875
      ],
      "bbox_min": [
        -2537.368408203125,
        -4058.762451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2530.80615234375,
        -4054.396484375,
        1112.623779296875
      ],
      "dimensions_source": {
        "span_x": 6.562255859375,
        "span_y": 4.365966796875,
        "height_z": 11.0,
        "door_width": 6.562255859375,
        "door_depth": 4.365966796875,
        "leaf_depth": 4.325966796875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -2537.368408203125,
          -4055.262451171875,
          1101.623779296875
        ],
        [
          -2537.368408203125,
          -4055.262451171875,
          1101.623779296875
        ],
        [
          -2537.368408203125,
          -4055.262451171875,
          1112.623779296875
        ],
        [
          -2531.30615234375,
          -4058.762451171875,
          1112.623779296875
        ],
        [
          -2531.30615234375,
          -4058.762451171875,
          1101.623779296875
        ],
        [
          -2531.30615234375,
          -4058.762451171875,
          1101.623779296875
        ],
        [
          -2536.868408203125,
          -4054.396484375,
          1112.623779296875
        ],
        [
          -2536.868408203125,
          -4054.396484375,
          1101.623779296875
        ],
        [
          -2530.80615234375,
          -4057.896484375,
          1101.623779296875
        ],
        [
          -2530.80615234375,
          -4057.896484375,
          1112.623779296875
        ]
      ],
      "plane_distance": 1101.6238,
      "authentic_texture": "basegatedoor"
    },
    {
      "tag": "CSlidingDoor piece: dbdorl",
      "entity_class": "CSlidingDoor",
      "piece_name": "dbdorl",
      "offset": 4014,
      "centroid": [
        -3107.46953125,
        -4964.0,
        1108.40146484375
      ],
      "bbox_min": [
        -3114.265625,
        -4965.2685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3099.999755859375,
        -4962.7314453125,
        1117.623779296875
      ],
      "dimensions_source": {
        "span_x": 14.265869140625,
        "span_y": 2.537109375,
        "height_z": 16.0,
        "door_width": 14.265869140625,
        "door_depth": 2.537109375,
        "leaf_depth": 2.497109375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3099.999755859375,
          -4965.2685546875,
          1117.623779296875
        ],
        [
          -3114.265625,
          -4965.2685546875,
          1106.5679931640625
        ],
        [
          -3108.816650390625,
          -4965.2685546875,
          1114.5679931640625
        ],
        [
          -3114.265625,
          -4965.2685546875,
          1101.623779296875
        ],
        [
          -3114.265625,
          -4962.7314453125,
          1101.623779296875
        ],
        [
          -3114.265625,
          -4962.7314453125,
          1106.5679931640625
        ],
        [
          -3108.816650390625,
          -4962.7314453125,
          1114.5679931640625
        ],
        [
          -3099.999755859375,
          -4962.7314453125,
          1117.623779296875
        ],
        [
          -3100.0,
          -4965.2685546875,
          1101.623779296875
        ],
        [
          -3100.0,
          -4962.7314453125,
          1101.623779296875
        ]
      ],
      "plane_distance": 3100.0168,
      "authentic_texture": "doorjam"
    }
  ],
  "tutorial_messages": []
}